module.exports = __webpack_public_path__ + "img/38.dc310331.jpg";